import {initRequest, RequestMethod} from "../../middlewares/request/requestActions";

export const FILE_SAVE_GENERIC_ACTION_LABEL = "fileSave/genericAction/label";

export const fileSave = (url, fileSave, baseUrl) => {
  return initRequest(
    FILE_SAVE_GENERIC_ACTION_LABEL,
    url,
    RequestMethod.GET,
    null,
    t => ({
      onStart: t("commons.actions.download.start")
    }),
    {fileSave: fileSave},
    baseUrl,
    undefined,
    undefined,
    undefined,
    true,
    undefined,
    true
  );
};
